module.exports = __webpack_public_path__ + "img/segmentation.3182d379.svg";